import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { downloadBlob } from "./utils.js";

export async function elementToPdfBlob(el, { format = "a4" } = {}) {
  const canvas = await html2canvas(el, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
  });
  const pdf = new jsPDF({
    orientation: canvas.width > canvas.height ? "landscape" : "portrait",
    unit: "mm",
    format,
  });
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const ratio = canvas.height / canvas.width;
  let w = pw;
  let h = pw * ratio;
  if (h > ph) {
    h = ph;
    w = ph / ratio;
  }
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", (pw - w) / 2, (ph - h) / 2, w, h);
  return pdf.output("blob");
}

export async function elementsToPdfBlob(elements, { format = "a4" } = {}) {
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format });
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  let first = true;
  for (const el of elements) {
    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
    });
    const ratio = canvas.height / canvas.width;
    let w = pw;
    let h = pw * ratio;
    if (h > ph) {
      h = ph;
      w = ph / ratio;
    }
    if (!first) pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", (pw - w) / 2, (ph - h) / 2, w, h);
    first = false;
  }
  return pdf.output("blob");
}

export function downloadPdfBlob(blob, name) {
  downloadBlob(blob, name);
}
